import { Clock, Zap, Shield, BadgeCheck } from "lucide-react";
import { WHY_US } from "@/lib/content";

const ICONS = [Clock, Zap, Shield, BadgeCheck];

export default function WhyUs() {
  return (
    <section data-testid="whyus-section" className="relative py-24 md:py-32 bg-gray-100 border-y border-gray-200 overflow-hidden">
      <div className="absolute -top-20 -right-20 w-96 h-96 rounded-full bg-violet-600/10 blur-2xl pointer-events-none" />
      <div className="absolute -bottom-20 -left-20 w-96 h-96 rounded-full bg-blue-600/10 blur-2xl pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-5">
            <div className="text-xs uppercase tracking-[0.3em] text-violet-600 font-bold mb-4">[ 04 ] · Miért minket</div>
            <h2 className="font-display font-black uppercase tracking-tighter text-4xl md:text-6xl leading-[0.95]">
              Profi.<br />Gyors.<br /><span className="bg-gradient-to-r from-blue-600 to-violet-600 bg-clip-text text-transparent">Megbízható.</span>
            </h2>
            <p className="mt-6 text-gray-500 leading-relaxed">
              Több ezer kiszálláson edződött csapatunk minden nap új helyzetekkel találkozik. Tudjuk, mit jelent a gyors és szakszerű megoldás.
            </p>

            <div className="mt-10 border border-gray-200 bg-gray-100/40 p-6 rounded-sm">
              <div className="text-[10px] uppercase tracking-[0.25em] text-violet-600 font-bold">Élő lefedettség</div>
              <div className="font-display text-2xl font-bold mt-2">Budapest + 100 km körzet</div>
              <div className="mt-3 text-sm text-gray-500">
                Az összes kerület, Pest megye és környéke — <span className="text-gray-900 font-semibold">Budapest + 100 km körzet</span>. Kiérkezés Budapesten belül <span className="text-gray-900 font-semibold">60 percen belül</span>.
              </div>
            </div>
          </div>

          <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-px bg-gray-100/10">
            {WHY_US.map((w, i) => {
              const Icon = ICONS[i] || Zap;
              return (
                <div
                  key={i}
                  data-testid={`whyus-card-${i}`}
                  className="bg-[#F0F1F5] p-7 md:p-9 hover:bg-white transition-colors group"
                >
                  <div className="flex items-start justify-between mb-6">
                    <Icon className="w-6 h-6 text-violet-600 group-hover:scale-110 transition-transform" />
                    <div className="font-display font-black text-3xl bg-gradient-to-br from-gray-900 to-violet-600 bg-clip-text text-transparent">{w.metric}</div>
                  </div>
                  <h3 className="font-display text-lg font-bold uppercase tracking-tight">{w.title}</h3>
                  <p className="text-sm text-gray-500 mt-2 leading-relaxed">{w.desc}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
